module.exports = (__webpack_require__("dll-reference chakra188"))(917);